var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel"
  }, [_vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('div', [_c('handlers-wrapper-button', {
    attrs: {
      "handlers": _vm.getHandlers()
    }
  }), _c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "stat-bar-filter"
  }, [_c('hypoteky-filters-bar', {
    on: {
      "period-filter-change": function periodFilterChange($event) {
        return _vm.filterForPeriod($event);
      },
      "broker-filter-change": function brokerFilterChange($event) {
        return _vm.filterMortgages('financnik', $event);
      },
      "filter-client": function filterClient($event) {
        return _vm.filterMortgages('search', $event);
      }
    }
  }), _c('hypoteky-stats')], 1)]), _c('hypoteky-items-wrapper')], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }